var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwitchApp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.166504 4.83366H4.33317V0.666992H0.166504V4.83366ZM6.4165 17.3337H10.5832V13.167H6.4165V17.3337ZM0.166504 17.3337H4.33317V13.167H0.166504V17.3337ZM0.166504 11.0837H4.33317V6.91699H0.166504V11.0837ZM6.4165 11.0837H10.5832V6.91699H6.4165V11.0837ZM12.6665 0.666992V4.83366H16.8332V0.666992H12.6665ZM6.4165 4.83366H10.5832V0.666992H6.4165V4.83366ZM12.6665 11.0837H16.8332V6.91699H12.6665V11.0837ZM12.6665 17.3337H16.8332V13.167H12.6665V17.3337Z",
    fill: "#FEA628"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchApp);
export default __webpack_public_path__ + "static/media/switch-app.344174d4258ef7d211c1b0a1ece404c8.svg";
export { ForwardRef as ReactComponent };